/* ===========================================================
   Gift Finder — comportamento
   - Filtros multi-select (occasion, recipient, profile)
   - Slider de preço dual (lo/hi)
   - Preview ao vivo de produtos
   - URL final construída como query Shopify para /search ou /collections/*
   =========================================================== */

(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-gift-finder]';
  const roots = document.querySelectorAll(ROOT_SELECTOR);
  if (!roots.length) return;

  // ============================================================
  // Tracking helper (GTM dataLayer)
  // Uma fonte de verdade no código → N destinos no GTM (GA4, Meta, etc).
  // Failure mode: se dataLayer não existir, cria array vazio e push fica
  // pendurado lá até GTM carregar (comportamento padrão GTM).
  // ============================================================
  function gfTrack(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
    } catch (e) {
      // Falha silenciosa — nunca quebrar o widget por causa de tracking.
      // console.debug pra dev poder ver sem virar spam em prod.
      if (window.console && console.debug) {
        console.debug('[GiftFinder] tracking failed:', e);
      }
    }
  }

  roots.forEach(initGiftFinder);

  function initGiftFinder(root) {
    // ---- DOM refs ----
    const $ = (sel, ctx = root) => ctx.querySelector(sel);
    const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));

    const productsScript = $('[data-gf-products]');
    let products = [];
    try {
      products = JSON.parse(productsScript.textContent || '[]');
    } catch (e) {
      console.error('[GiftFinder] Falha ao parsear produtos JSON', e);
      return;
    }

    // ---- State ----
    // occasion + recipient = SINGLE-select (string ou null). Razão UX:
    //   cliente busca "presente pra aniversário da mãe", não múltiplas
    //   ocasiões/destinatários combinados.
    // profile = MULTI-select (Set). Personalidade pode ser composta
    //   (Romântica + Criativa, Gourmet + Sofisticado, etc).
    const initialLo = parseInt(root.querySelector('[data-gf-slider="lo"]').value, 10);
    const initialHi = parseInt(root.querySelector('[data-gf-slider="hi"]').value, 10);
    const state = {
      occasion: null,
      recipient: null,
      profile: new Set(),
      priceLo: initialLo,
      priceHi: initialHi,
      priceMin: parseInt(root.querySelector('[data-gf-slider="lo"]').min, 10),
      priceMax: parseInt(root.querySelector('[data-gf-slider="lo"]').max, 10),
      // Defaults vindos da section — usados pra detectar se cliente mexeu no slider
      priceLoDefault: initialLo,
      priceHiDefault: initialHi
    };

    // Grupos single-select (1 valor por vez). Profile fica de fora.
    const SINGLE_GROUPS = new Set(['occasion', 'recipient']);

    // ---- Bind chips ----
    $$('.gift-finder__chip').forEach(chip => {
      chip.setAttribute('aria-pressed', 'false');
      chip.addEventListener('click', () => {
        const group = chip.dataset.gfFilter;
        const value = chip.dataset.gfValue;
        let action; // 'selected' | 'deselected' (pro tracking)

        if (SINGLE_GROUPS.has(group)) {
          // Single-select: clicar no atual desseleciona; clicar em outro
          // troca a seleção (desseleciona o anterior visualmente).
          if (state[group] === value) {
            state[group] = null;
            chip.setAttribute('aria-pressed', 'false');
            action = 'deselected';
          } else {
            state[group] = value;
            // Desseleciona qualquer outro chip do mesmo grupo
            $$(`.gift-finder__chip[data-gf-filter="${group}"]`).forEach(c => {
              c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
            });
            action = 'selected';
          }
        } else {
          // Multi-select (profile): toggle no Set.
          if (state[group].has(value)) {
            state[group].delete(value);
            chip.setAttribute('aria-pressed', 'false');
            action = 'deselected';
          } else {
            state[group].add(value);
            chip.setAttribute('aria-pressed', 'true');
            action = 'selected';
          }
        }
        gfTrack('gift_finder_filter_applied', {
          gf_filter_group: group,    // 'occasion' | 'recipient' | 'profile'
          gf_filter_value: value,    // ex: 'ocasiao-aniversario'
          gf_filter_action: action,  // 'selected' | 'deselected'
        });
        render();
      });
    });

    // ---- Bind sliders ----
    const sliderLo = $('[data-gf-slider="lo"]');
    const sliderHi = $('[data-gf-slider="hi"]');

    // Debounce do tracking de preço pra não spammar dataLayer no arrasto.
    let priceTrackTimer;
    function trackPriceChange(source) {
      clearTimeout(priceTrackTimer);
      priceTrackTimer = setTimeout(() => {
        gfTrack('gift_finder_price_changed', {
          gf_price_lo: state.priceLo,
          gf_price_hi: state.priceHi,
          gf_price_source: source, // 'slider' | 'preset'
        });
      }, 600);
    }

    sliderLo.addEventListener('input', () => {
      state.priceLo = Math.min(parseInt(sliderLo.value, 10), state.priceHi - 10);
      sliderLo.value = state.priceLo;
      trackPriceChange('slider');
      render();
    });
    sliderHi.addEventListener('input', () => {
      state.priceHi = Math.max(parseInt(sliderHi.value, 10), state.priceLo + 10);
      sliderHi.value = state.priceHi;
      trackPriceChange('slider');
      render();
    });

    // ---- Bind price presets ----
    $$('[data-gf-preset]').forEach(btn => {
      btn.addEventListener('click', () => {
        const [lo, hi] = btn.dataset.gfPreset.split(',').map(n => parseInt(n, 10));
        state.priceLo = lo;
        state.priceHi = hi;
        sliderLo.value = lo;
        sliderHi.value = hi;
        trackPriceChange('preset');
        render();
      });
    });

    // ---- Bind CTA (tracking de clique antes da navegação) ----
    $('[data-gf-cta]').addEventListener('click', (ev) => {
      // CTA disabled: não dispara evento, deixa o aria-disabled bloquear nav
      if (ev.currentTarget.classList.contains('is-disabled')) return;
      gfTrack('gift_finder_cta_click', {
        gf_occasion: state.occasion || '',
        gf_recipient: state.recipient || '',
        gf_profiles: Array.from(state.profile),
        gf_price_lo: state.priceLo,
        gf_price_hi: state.priceHi,
        gf_result_count: filtered().length,
        gf_destination: ev.currentTarget.href || '',
      });
      // NÃO chamar preventDefault — deixa o navegador navegar normalmente
    });

    // ---- Bind clear ----
    $('[data-gf-clear]').addEventListener('click', () => {
      state.occasion = null;
      state.recipient = null;
      state.profile.clear();
      state.priceLo = state.priceLoDefault;
      state.priceHi = state.priceHiDefault;
      sliderLo.value = state.priceLo;
      sliderHi.value = state.priceHi;
      $$('.gift-finder__chip').forEach(c => c.setAttribute('aria-pressed', 'false'));
      render();
    });

    // ---- Filter logic ----
    function filtered() {
      return products.filter(p => {
        if (p.price < state.priceLo || p.price > state.priceHi) return false;
        const tagSet = new Set(p.tags || []);
        // occasion/recipient: single-select (string ou null)
        if (state.occasion && !tagSet.has(state.occasion)) return false;
        if (state.recipient && !tagSet.has(state.recipient)) return false;
        // profile: multi-select (Set) — produto precisa ter AO MENOS um dos perfis
        if (state.profile.size && !anyMatch(state.profile, tagSet)) return false;
        return true;
      });
    }

    function anyMatch(needles, haystack) {
      for (const n of needles) if (haystack.has(n)) return true;
      return false;
    }

    // ---- Boost / priorização ----
    // Convenção de tag:
    //   destaque-<filtro>             → destaque sem ordem (order = 999)
    //   destaque-<filtro>-<N>         → destaque com ordem N (menor = mais alto)
    // Exemplos: destaque-ocasiao-aniversario-1, destaque-para-mae-2,
    //           destaque-perfil-romantica
    //
    // Score do produto = soma de destaques relevantes; tie-break pela menor
    // ordem encontrada. Quando há filtro ativo, só destaques que casam contam.
    // Sem filtro ativo, TODOS os destaque-* do produto contam (vitrine geral).
    const BOOST_RE = /^destaque-(ocasiao-.+?|para-.+?|perfil-.+?)(?:-(\d+))?$/;

    function getActiveFilterTags() {
      const tags = [];
      if (state.occasion)  tags.push(state.occasion);
      if (state.recipient) tags.push(state.recipient);
      state.profile.forEach(t => tags.push(t));
      return tags;
    }

    function getBoostScore(product) {
      const activeFilters = getActiveFilterTags();
      const noFilterActive = activeFilters.length === 0;
      let score = 0;
      let minOrder = 999999;

      for (const tag of product.tags || []) {
        const m = tag.match(BOOST_RE);
        if (!m) continue;
        // Anchor: nome do filtro alvo do destaque (ex: "ocasiao-aniversario")
        const targetFilter = m[1];
        const order = m[2] != null ? parseInt(m[2], 10) : 999;
        // Conta o destaque se: sem filtro ativo (vitrine), OU o destaque
        // refere a um filtro atualmente ativo.
        if (noFilterActive || activeFilters.includes(targetFilter)) {
          score += 1;
          if (order < minOrder) minOrder = order;
        }
      }
      return { score, order: minOrder };
    }

    function sortByBoost(list) {
      // Decora cada item com {boost, originalIndex} pra sort estável
      return list
        .map((p, i) => ({ p, i, boost: getBoostScore(p) }))
        .sort((a, b) => {
          if (a.boost.score !== b.boost.score) return b.boost.score - a.boost.score;
          if (a.boost.order !== b.boost.order) return a.boost.order - b.boost.order;
          return a.i - b.i; // ordem natural da coleção como último tiebreak
        })
        .map(x => x.p);
    }

    function hasAnyFilter() {
      return !!state.occasion || !!state.recipient || state.profile.size > 0;
    }

    function buildResultUrl() {
      const baseUrl = root.dataset.resultsUrl || '/collections/all';
      const params = new URLSearchParams();
      if (state.occasion)  params.append('filter.p.tag', state.occasion);
      if (state.recipient) params.append('filter.p.tag', state.recipient);
      state.profile.forEach(t => params.append('filter.p.tag', t));
      params.append('filter.v.price.gte', state.priceLo);
      params.append('filter.v.price.lte', state.priceHi);
      return baseUrl + '?' + params.toString();
    }

    // ---- Render ----
    let lastCount = -1;
    function render() {
      updatePriceUI();
      updatePresetsUI();
      const matches = filtered();
      updateCount(matches.length);
      updateGrid(matches);
      updateCta(matches.length);
      updateEmpty(matches.length);
      updateClear();
    }

    function updatePriceUI() {
      const range = $('[data-gf-range]');
      const lo = state.priceLo, hi = state.priceHi;
      const min = state.priceMin, max = state.priceMax;
      const loPct = ((lo - min) / (max - min)) * 100;
      const hiPct = ((hi - min) / (max - min)) * 100;
      range.style.left = loPct + '%';
      range.style.right = (100 - hiPct) + '%';
      $('[data-gf-price-lo]').textContent = 'R$ ' + lo;
      $('[data-gf-price-hi]').textContent = 'R$ ' + hi + (hi === max ? '+' : '');
    }

    function updatePresetsUI() {
      $$('[data-gf-preset]').forEach(btn => {
        const [lo, hi] = btn.dataset.gfPreset.split(',').map(n => parseInt(n, 10));
        const active = state.priceLo === lo && state.priceHi === hi;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function updateCount(n) {
      const numEl = $('[data-gf-count]');
      const lblEl = $('[data-gf-count-label]');
      numEl.textContent = n;
      lblEl.textContent = n === 1 ? 'cesta encontrada' : 'cestas encontradas';
      const eyebrow = $('[data-gf-eyebrow]');
      eyebrow.textContent = hasAnyFilter() ? 'RESULTADO CURADO' : 'ENQUANTO VOCÊ ESCOLHE...';
      if (n !== lastCount) {
        numEl.classList.remove('gf-bump');
        // force reflow to restart animation
        void numEl.offsetWidth;
        numEl.classList.add('gf-bump');
        lastCount = n;
      }
    }

    function updateGrid(matches) {
      const grid = $('[data-gf-grid]');
      grid.innerHTML = '';
      // Aplica priorização (boost por tags destaque-*) antes de fatiar.
      // O preview só mostra 4 — sort garante que os destaques cheguem ao topo.
      const sorted = sortByBoost(matches);
      const slice = sorted.slice(0, 4);
      slice.forEach(p => grid.appendChild(buildCard(p)));
      for (let i = slice.length; i < 4; i++) {
        const empty = document.createElement('div');
        empty.className = 'gf-card-empty';
        grid.appendChild(empty);
      }
    }

    function buildCard(p) {
      const a = document.createElement('a');
      a.className = 'gf-card';
      a.href = p.url || '#';

      const fmt = v => 'R$ ' + Math.round(v);
      const discount = p.compare_at_price ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
      const badgeClass = (p.badge || '').toLowerCase().includes('novidade') ? 'gf-card__badge--yellow' : '';

      a.innerHTML = `
        <div class="gf-card__media">
          ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">` : `<div class="gf-card__placeholder">🎁</div>`}
          ${p.badge ? `<span class="gf-card__badge ${badgeClass}">${escapeHtml(p.badge)}</span>` : ''}
          ${discount > 0 ? `<span class="gf-card__discount">-${discount}%</span>` : ''}
        </div>
        <div class="gf-card__body">
          <div class="gf-card__title">${escapeHtml(p.title)}</div>
          ${ratingHtml(p.rating, p.rating_count)}
          <div class="gf-card__price">
            ${p.compare_at_price ? `<span class="gf-card__price-old">${fmt(p.compare_at_price)}</span>` : ''}
            <span class="gf-card__price-new">${fmt(p.price)}</span>
          </div>
        </div>
      `;
      return a;
    }

    function ratingHtml(rating, count) {
      // Esconde o bloco inteiro se produto ainda não tem avaliação real.
      // (Evita constelação fake de estrelas e o "0 avaliações" deselegante.)
      if (rating == null || (count || 0) === 0) return '';
      const full = Math.max(0, Math.min(5, Math.round(rating)));
      let stars = '';
      for (let i = 1; i <= 5; i++) {
        stars += i <= full
          ? '<span class="gf-card__star gf-card__star--on">★</span>'
          : '<span class="gf-card__star gf-card__star--off">★</span>';
      }
      return `<div class="gf-card__rating">${stars}<span class="gf-card__rating-count">(${count})</span></div>`;
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function updateCta(n) {
      const cta = $('[data-gf-cta]');
      const label = $('[data-gf-cta-label]');
      cta.href = buildResultUrl();
      if (n === 0) {
        cta.classList.add('is-disabled');
        cta.setAttribute('aria-disabled', 'true');
        label.textContent = 'Nenhuma cesta com esses filtros';
      } else {
        cta.classList.remove('is-disabled');
        cta.removeAttribute('aria-disabled');
        label.textContent = n > 4 ? `Ver as ${n} cestas` : 'Ver minhas cestas';
      }
    }

    // Estado vazio: dispara evento UMA vez na transição pra zero (não a
    // cada render). Reseta quando volta a ter resultado.
    let wasEmpty = false;
    function updateEmpty(n) {
      $('[data-gf-empty]').hidden = n !== 0;
      if (n === 0 && !wasEmpty && hasAnyFilter()) {
        wasEmpty = true;
        gfTrack('gift_finder_empty_state', {
          gf_occasion: state.occasion || '',
          gf_recipient: state.recipient || '',
          gf_profiles: Array.from(state.profile),
          gf_price_lo: state.priceLo,
          gf_price_hi: state.priceHi,
        });
      } else if (n > 0) {
        wasEmpty = false;
      }
    }

    function updateClear() {
      const isFiltered = hasAnyFilter()
        || state.priceLo !== state.priceLoDefault
        || state.priceHi !== state.priceHiDefault;
      $('[data-gf-clear]').hidden = !isFiltered;
    }

    // ---- Hidratar produtos via AJAX (>50) ----
    // Liquid serializa só 50 produtos por causa do limite do collection.products
    // em section de template index. Pra pegar até 250, busca em background
    // via endpoint público /collections/<handle>/products.json e merge no
    // estado em memória, re-renderizando ao final.
    //
    // Trade-off: badge e rating só vêm dos 50 do Liquid (metafields não saem
    // no products.json). Os produtos AJAX-only têm badge='' e rating=null.
    hydrateFullCatalog();

    function hydrateFullCatalog() {
      const handle = root.dataset.collectionHandle;
      const desiredLimit = parseInt(root.dataset.productLimit, 10) || 200;
      if (!handle) return;                       // sem coleção, nada a fazer
      if (products.length >= desiredLimit) return; // Liquid já entregou tudo
      if (desiredLimit <= 50) return;            // setting baixo, sem hidrato

      const fetchLimit = Math.min(desiredLimit, 250); // hard cap Shopify
      fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=${fetchLimit}`, {
        credentials: 'same-origin',
      })
        .then(r => r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`))
        .then(data => {
          const ajaxProducts = (data.products || []).map(mapAjaxProduct);
          const existingIds = new Set(products.map(p => p.id));
          const novos = ajaxProducts.filter(p => !existingIds.has(p.id));
          if (novos.length > 0) {
            products = products.concat(novos);
            render(); // re-render com produtos novos
          }
        })
        .catch(err => {
          if (window.console && console.debug) {
            console.debug('[GiftFinder] hidrato falhou:', err);
          }
        });
    }

    function mapAjaxProduct(p) {
      // Shape do /products.json é diferente do JSON inline do Liquid.
      // Mapeia pro mesmo formato pra render() funcionar igual.
      //
      // /products.json devolve price como STRING ("120.00") em REAIS já.
      // Liquid `product.price` é o preço MÍNIMO das variantes — replico aqui.
      const prices = (p.variants || [])
        .map(v => parseFloat(v.price))
        .filter(n => !isNaN(n));
      const price = prices.length ? Math.min(...prices) : 0;
      const compareAts = (p.variants || [])
        .map(v => parseFloat(v.compare_at_price))
        .filter(n => !isNaN(n) && n > price);
      const compareAt = compareAts.length ? Math.min(...compareAts) : null;

      // Imagem: prefere a destacada (image); cai pra primeira de images[].
      let imageSrc = (p.image && p.image.src) || (p.images && p.images[0] && p.images[0].src) || null;
      if (imageSrc) {
        // Aplica crop 400×400 via query params (formato Shopify CDN moderno).
        // Remove qualquer query string pré-existente pra não duplicar.
        imageSrc = imageSrc.split('?')[0] + '?width=400&height=400&crop=center';
      }

      // Tags vêm como string ou array no /products.json (depende da versão)
      const tags = Array.isArray(p.tags) ? p.tags
                 : (typeof p.tags === 'string' ? p.tags.split(/,\s*/).filter(Boolean) : []);

      return {
        id: p.id,
        handle: p.handle,
        title: p.title,
        url: `/products/${p.handle}`,
        image: imageSrc,
        price: price,
        compare_at_price: compareAt,
        tags: tags,
        // Limitações do /products.json — metafields não vêm:
        badge: '',
        rating: null,
        rating_count: 0,
      };
    }

    // ---- Tracking: view (1× por sessão da página) ----
    if ('IntersectionObserver' in window) {
      let viewed = false;
      const viewObserver = new IntersectionObserver((entries) => {
        if (!viewed && entries.some(e => e.isIntersecting)) {
          viewed = true;
          gfTrack('gift_finder_view', { gf_products_loaded: products.length });
          viewObserver.disconnect();
        }
      }, { threshold: 0.3 });
      viewObserver.observe(root);
    } else {
      // Browsers antigos: dispara view direto, sem condição de viewport
      gfTrack('gift_finder_view', { gf_products_loaded: products.length });
    }

    // ---- Initial render ----
    render();
  }
})();
